import { gql } from '@apollo/client';

export const resetPersonConsent = gql`
  mutation resetPersonConsent(
    $oid: PersonConsentId!
    $issuerPersonId: PersonId!
    $actionAt: DateTime!
  ) {
    resetPersonConsent(
      input: { oid: $oid, issuerPersonId: $issuerPersonId, actionAt: $actionAt }
    ) {
      id
      oid
    }
  }
`;
